var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rbt-separator-mid"},[_c('div',{staticClass:"container"},[_c('hr',{staticClass:"rbt-separator m-0",staticStyle:{"border-top":"1px solid #787872"}})])])
}]

export { render, staticRenderFns }